import backend, {AGENTCORE_ENGINE_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const listDomainGuides = ({includeRawDomainGuide, teamName} = {}) => {
  const queryParam = {
    includeRawDomainGuide,
    teamName,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = query ?
    `${AGENTCORE_ENGINE_API}/domain_guide?${query}` :
    `${AGENTCORE_ENGINE_API}/domain_guide`;
  return backend.get(url);
};

const getDomainGuide = (domainGuideRn) => {
  const url = `${AGENTCORE_ENGINE_API}/domain_guide/${domainGuideRn}`;
  return backend.get(url);
};

const updateStatus = (domainGuideRn, status) => {
  const url = `${AGENTCORE_ENGINE_API}/domain_guide/${domainGuideRn}/status`;
  const body = {
    status,
  };
  return backend.put(url, body);
};

const updateTeamName = (domainGuideRn, teamName) => {
  const url = `${AGENTCORE_ENGINE_API}/domain_guide/${domainGuideRn}/team_name`;
  const body = {
    teamName,
  };
  return backend.put(url, body);
};

const updateOutreachHours = (domainGuideRn, outreachHours) => {
  const url = `${AGENTCORE_ENGINE_API}/domain_guide/${domainGuideRn}/outreach_hours`;
  const body = {
    outreachHours,
  };
  return backend.put(url, body);
};

const updateRubric = (domainGuideRn, rubric) => {
  const url = `${AGENTCORE_ENGINE_API}/domain_guide/${domainGuideRn}/rubric`;
  const body = {
    rubric,
  };
  return backend.put(url, body);
};

const updateMarking = (domainGuideRn, marking) => {
  const url = `${AGENTCORE_ENGINE_API}/domain_guide/${domainGuideRn}/marking`;
  const body = {
    marking,
  };
  return backend.put(url, body);
};

const updateSlackIds = (domainGuideRn, slackIds) => {
  const url = `${AGENTCORE_ENGINE_API}/domain_guide/${domainGuideRn}/slack_id`;
  const body = {
    slackIds,
  };
  return backend.put(url, body);
};

export default {
  getDomainGuide,
  listDomainGuides,
  updateMarking,
  updateRubric,
  updateStatus,
  updateSlackIds,
  updateTeamName,
  updateOutreachHours,
};
